


import { environment as ngEnvironment } from './environment';

/*

The environment wrapper serves as the entry point for angular code to get the environment
specific variables. From a consumer point of view it looks similar to getting
environment data from the NG build system. But it differes in that we store all possible
environment configs in the app bundle so they can be changed after the NG build has completed.
But it is compatible with the --environment flags of NG commands.

*/

export interface EnvironmentSpec {
    production: boolean,
    baseServerUrl: string, //Url to raw server
    cdnServerUrl: string, //Url to CDN-ed server
    isLocal: boolean,
    cookieDomain: string,
    imageBucket: string,
    staticResourceRoot: string,
    sw: boolean,
    clustererCacheSeconds: number,
    brokerageUUID: string,
    testChatUsers: boolean
}

declare var global_ngEnvOverride: string;

const environments: {[key: string]: EnvironmentSpec} = {
    dev: {
        production: false,
        cdnServerUrl: 'https://dev-mobile.remax-integra.net/',
        baseServerUrl: 'https://dev-api-mobile.remax-integra.net/',
        isLocal: false,
        cookieDomain: '.remax-integra.net',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: 'https://remax-devapp.imgix.net/',
        sw: true,
        clustererCacheSeconds: 300,
        brokerageUUID: '576f9cf7-d878-4215-985e-a43cdb1c6bd3',
        testChatUsers: true
    },
    localSsr: {
        production: false,
        baseServerUrl: 'http://localhost:5000/',
        cdnServerUrl: 'http://localhost:5000/',
        isLocal: true,
        cookieDomain: '.localhost',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: 'http://localhost:4000/',
        sw: true,
        clustererCacheSeconds: 300,
        brokerageUUID: '576f9cf7-d878-4215-985e-a43cdb1c6bd3',
        testChatUsers: true
    },
    localWithDevServer: {
        production: false,
        baseServerUrl: 'https://dev-api-mobile.remax-integra.net/',
        cdnServerUrl: 'https://dev-mobile.remax-integra.net/',
        isLocal: true,
        cookieDomain: '.dev-api-mobile.remax-integra.net',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: '',
        sw: false,
        clustererCacheSeconds: 300,
        brokerageUUID: '576f9cf7-d878-4215-985e-a43cdb1c6bd3',
        testChatUsers: true
    },
    local: {
        production: false,
        baseServerUrl: 'http://localhost:5000/',
        cdnServerUrl: 'http://localhost:5000/',
        isLocal: true,
        cookieDomain: '.localhost',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: '',
        sw: false,
        clustererCacheSeconds: 300,
        brokerageUUID: '576f9cf7-d878-4215-985e-a43cdb1c6bd3',
        testChatUsers: true
    },
    preprod: {
        production: false,
        baseServerUrl: 'https://preprod-api-mobile.remax-integra.net/',
        cdnServerUrl: 'https://preprod-mobile.remax-integra.net/',
        isLocal: false,
        cookieDomain: '.remax-integra.net',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: 'https://remax-preprodapp.imgix.net/',
        sw: true,
        clustererCacheSeconds: 300,
        brokerageUUID: '7472638c-5b5e-4560-a599-7a109f5797c6',
        testChatUsers: false
    },
    prod: {
        production: true,
        baseServerUrl: 'https://api.remax.ca/',
        cdnServerUrl: 'https://www.remax.ca/',
        isLocal: false,
        cookieDomain: '.remax.ca',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: 'https://remax-prodapp.imgix.net/',
        sw: true,
        clustererCacheSeconds: 300,
        brokerageUUID: '7472638c-5b5e-4560-a599-7a109f5797c6',
        testChatUsers: false
    },
    qa: {
        production: false,
        baseServerUrl: 'https://qa-api-mobile.remax-integra.net/',
        cdnServerUrl: 'https://qa-mobile.remax-integra.net/',
        isLocal: false,
        cookieDomain: '.remax-integra.net',
        imageBucket: 'https://dev-publicsite-images.s3.amazonaws.com/',
        staticResourceRoot: 'https://remax-qaapp.imgix.net/',
        sw: true,
        clustererCacheSeconds: 300,
        brokerageUUID: '576f9cf7-d878-4215-985e-a43cdb1c6bd3',
        testChatUsers: true
    }
};

let environmentTag = ngEnvironment.environmentTag;
if (typeof process != 'undefined' && process && process.env && process.env.APP_ENV) {
    environmentTag = process.env.APP_ENV;
} else if (typeof global_ngEnvOverride !== 'undefined' && global_ngEnvOverride in environments) {
    environmentTag = global_ngEnvOverride;
}

export const environment: EnvironmentSpec = environments[environmentTag];
